import {Injectable, Inject} from 'ng-metadata/core';
import {SearchStateService} from '../search/searchState.service';
import {SearchFieldsService} from '../search/search.fields.service';
import {getVid, getAttributesMap} from '../appConfig/appConfigForward';
import {getUrlContext} from '../appConfig/appConfigForward';
import {PermalinkService} from '../search/actions/permalinkAction/permalink.service';
import {JournalsService} from "../journals/journals.service";
import {STATE_NAMES} from "../primoExplore/primoExploreStates.module";
import {DatabasesService} from "../journals/databases.service";
import {NewspapersService} from '../newspapers/newspapers.service';
import {JwtUtilService} from "../security/jwtUtil.service";
import {UserSessionManagerService} from "../security/userSessionManager.service";
import {AuthoritySearchService} from "../search/authority/authoritySearch.service";
import { ResearchAssistantService } from '../researchAssistant/researchAssistant.service';
const flatten= require('lodash/flatten');


@Injectable()
export class TemplateUtil{
    private vid:string= getVid();
    
    private urlContext:string= getUrlContext();
    private SHOW_PNX_IN_XML_URL: string;

    constructor(@Inject('$location') private $location: ng.ILocationService,
                private searchStateService : SearchStateService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                private searchFieldsService: SearchFieldsService,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                @Inject('restBaseURLs') private restBaseURLs,
                private permalinkService: PermalinkService,
                private databasesService: DatabasesService,
                private journalsService: JournalsService,
                private newspapersService : NewspapersService,
                private authoritySearchService : AuthoritySearchService,
                private  jwtUtilService: JwtUtilService,
                private userSessionManagerService: UserSessionManagerService,
                private researchAssistantService: ResearchAssistantService,
                @Inject('$interpolate') private $interpolate) {
        this.$location = $location;
        this.SHOW_PNX_IN_XML_URL= restBaseURLs.showPnxInXmlUrl+'/';
    }

    getBaseUrl() {
        return this.$location.absUrl().substring(0, this.$location.absUrl().indexOf(this.urlContext+"/") - 1);
    }

    parseParametersFromItemIdField(itemRestUrl) {
        let parametersObj = {
            context:itemRestUrl.context,
            id:itemRestUrl.pnx.control.recordid[0]
        };
        return parametersObj;
    }


    public prmParseKeyValue(/**string*/keyValue) {
        var obj = {};
        let kVArr = (keyValue || '').split('&');
        var _this = this;
        kVArr.forEach(function(keyValue) {
            var splitPoint, key, val;
            if (keyValue) {
                key = keyValue = keyValue.replace(/\+/g,'%20');
                splitPoint = keyValue.indexOf('=');
                if (splitPoint !== -1) {
                    key = keyValue.substring(0, splitPoint);
                    val = keyValue.substring(splitPoint + 1);
                }
                key = _this.prmTryDecodeURIComponent(key);
                if (angular.isDefined(key)) {
                    val = angular.isDefined(val) ? _this.prmTryDecodeURIComponent(val) : true;
                    if (!angular.hasOwnProperty.call(obj, key)) {
                        obj[key] = val;
                    } else if (angular.isArray(obj[key])) {
                        obj[key].push(val);
                    } else {
                        obj[key] = [obj[key],val];
                    }
                }
            }
        });
        return obj;
    }

    private prmTryDecodeURIComponent(value) {
        try {
            return decodeURIComponent(value);
        } catch (e) {
            // Ignore any invalid uri component.
        }
    }

    getDeepLinkPath(item, scope?, adaptor?) {

        let fullDisplayURL = this.getBaseDeepLinkPath(item, scope, adaptor);

        fullDisplayURL+= this.searchFieldsService.tab? '&tab=' + this.searchFieldsService.tab: '';
        fullDisplayURL+= this.getQueryDeepLink();
        fullDisplayURL+= this.$stateParams['sortby']? '&sortby=' + this.$stateParams['sortby'] : '';
        //fullDisplayURL+= '&tab=' + this.searchFieldsService.tab + '&query=' + this.$stateParams.query + '&sortby=' + this.$stateParams.sortby;
        fullDisplayURL+= this.getFacetsDeepLink();
        fullDisplayURL+= this.$stateParams['mode']? '&mode='+ this.$stateParams['mode']: '';
        fullDisplayURL+= this.$stateParams['searchType']? '&searchType='+ this.$stateParams['searchType']: '';
        fullDisplayURL+= this.$stateParams['barcode']? '&barcode='+ this.$stateParams['barcode']: '';
        fullDisplayURL+= this.getPfiltersDeepLink();
        fullDisplayURL+= this.$stateParams['offset']? '&offset=' + this.$stateParams['offset'] : '';
        fullDisplayURL+= this.$stateParams['journals']? '&journals=' + this.$stateParams['journals'] : '';
        fullDisplayURL+= this.$stateParams['databases']? '&databases=' + this.$stateParams['databases'] : '';
        fullDisplayURL+= this.$stateParams['pcAvailability']? '&pcAvailability=' + this.$stateParams['pcAvailability'] : '';
        fullDisplayURL+= this.$stateParams['searchInFulltext']? '&searchInFulltext=' + this.$stateParams['searchInFulltext'] : '';
        fullDisplayURL+= this.$stateParams['searchCDI']? '&searchCDI=' + this.$stateParams['searchCDI'] : '';
        fullDisplayURL+= this.$stateParams['citationTrailFilterByAvailability']? '&citationTrailFilterByAvailability=' + this.$stateParams['citationTrailFilterByAvailability'] : '';

        return fullDisplayURL;
    }

    public getCurState(item) {
        let state = 'fulldisplay';
        if(this.journalsService.isJournalSearch()){
            state = STATE_NAMES.JOURNAL_FULL_DISPLAY;
        }
        else if(this.databasesService.isDBSearch()){
            state = STATE_NAMES.DB_FULL_DISPLAY;
        }
        else if(item && (this.newspapersService.isNewspapersSearch() || this.newspapersService.isNewspaperItem(item))){
            state = STATE_NAMES.NEWSPAPERS_FULL_DISPLAY;
        }
        else if(this.authoritySearchService.isAuthorityState()){
            state = STATE_NAMES.AUTHORITY_FULL_DISPLAY;
        }
        else if(this.researchAssistantService.isSearchAssistant){
            state = STATE_NAMES.RESEARCH_ASSISTANT;
        }
        return state;
    }
    
    private getBaseDeepLinkPath(item, scope, adaptor) {
        let state = this.getCurState(item);
        if(!scope && !this.databasesService.isDBSearch() && !this.journalsService.isJournalSearch()){
            scope = this.searchStateService.getSearchObject().scope;
        }
        let recordid = this.permalinkService.getRecordId(item.pnx.control);
        
        if(item.context === 'NP'){
            recordid = this.permalinkService.getNewspapersRecordId(item.pnx.control);
        }
        let fullDisplayURL = '/' +  state + '?' + 'docid=' + recordid + '&context=' + item.context + '&vid=' + this.vid +
            '&lang=' + this.$translate.use();
        if(scope){
            fullDisplayURL+= '&search_scope=' + scope;
        }

        if (adaptor || item.adaptor) {
            fullDisplayURL = fullDisplayURL + '&adaptor=' + (adaptor ? adaptor : item.adaptor)
        }

        if (item.context === 'L' && this.isFrbr(item) && scope) {
            fullDisplayURL = fullDisplayURL + "&isFrbr=true";
        }

        return fullDisplayURL;
    }

    private getFacetsDeepLink(){
        let facets= this.$stateParams['facet'] ? [this.$stateParams['facet']] : [];
        facets= flatten(facets);
        let facetsDeepLink='';
        for(let i=0; i< facets.length; i++){
            facetsDeepLink+= '&facet=' + encodeURIComponent(facets[i]);
        }
        return facetsDeepLink;
    }

    private getPfiltersDeepLink(){
        let pfilters= this.$stateParams['pfilter'] ? [this.$stateParams['pfilter']] : [];
        pfilters= flatten(pfilters);
        let pfilterDeepLink='';
        for(let i=0; i< pfilters.length; i++){
            pfilterDeepLink+= '&pfilter=' + encodeURIComponent(pfilters[i]);
        }
        return pfilterDeepLink;
    }

    private getQueryDeepLink(){
        let query= this.$stateParams['query'] ? [this.$stateParams['query']] : [];
        query= flatten(query);
        let queryDeepLink='';
        for(let i=0; i< query.length; i++){
            queryDeepLink+= '&query=' + encodeURIComponent(query[i]);
        }
        return queryDeepLink;
    }

    getDeepLinkAbsPath(item, scope?, adaptor?) {
        return this.getBaseUrl() + '/' + this.urlContext + this.getBaseDeepLinkPath(item, scope,adaptor);
    }

    getFullDeepLinkAbsPath(item){
        return this.getBaseUrl() + '/' + this.urlContext + this.getDeepLinkPath(item);
    }

    getXmlDeepLinkAbsPath(item){
        return this.getBaseUrl() + '/' + this.urlContext + this.getDeepLinkPath(item);
    }

    isFrbr(item) {
        if (item.pnx.facets != undefined){
            if (!item || !item.pnx.facets.frbrtype) {
                return false;
            }
            let isFrbr = (item.pnx.facets.frbrtype[0] === '7' || item.pnx.facets.frbrtype[0] === '5');
            return (isFrbr);
        }
        return false;
    }

    public resolveUrlTemplate(url: string, interpolateParams?: Object) {
        let pdsHandle = this.jwtUtilService.getPdsHandle();
        let jwt = (this.jwtUtilService.getJwtFromLocalStorage() || '').replace(/"/g,'');
        let institution = this.jwtUtilService.getInstitutionCode();
        let language = this.$translate.use();
        let languageBib = this.getThreeLetterLanguage(language);
        let params = Object.assign({INST_CODE:institution, pds_handle:pdsHandle,
                jwt:jwt, language:language, language_bibliographic:languageBib,
                view:this.vid , userid: this.userSessionManagerService.getUserName()},
            interpolateParams);
        url = this.$interpolate(url)(params);
        return url;
    }

    private getThreeLetterLanguage(language) {
        let languages = getAttributesMap().interfaceLanguageOptions.split(',');
        let threeLettersLanguages = getAttributesMap().threeLettersLanguagesOptions.split(',');
        let index = languages.indexOf(language);
        if (index != -1) {
            return threeLettersLanguages[index];
        }
        return threeLettersLanguages[0];
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/templateUtil.service.ts